import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldComponent, FieldSet} from '@simpli/meta-schema'
import {NftCollection} from '@/model/resource/NftCollection'
import * as Component from '@simpli/vue-render-schema'
import RenderCopy from '@/components/RenderCopy.vue'
import NftCollectionCellRender from '@/components/render/NftCollectionCellRender.vue'

export class ListNftCollectionSchema extends DefaultSchema {
  readonly name = 'ListNftCollection'

  readonly fieldSet: FieldSet<NftCollection> = {
    imageUrl: (schema): FieldComponent => ({
      is: Component.RenderImage,
      bind: {
        src: schema.model.imageUrl,
        alt: this.translateFrom(schema.fieldName),
        innerClass: 'w-14 rounded-full',
      },
    }),
    nftCellRender: (schema): FieldComponent => ({
      is: NftCollectionCellRender,
      bind: {
        nftCollection: schema.model,
      },
    }),
    hash: (): FieldComponent => ({
      is: RenderCopy,
    }),
    averagePriceWeek: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.averagePriceWeekFormatted,
      },
    }),
    lowestPrice: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.lowestPriceFormatted,
      },
    }),
    totalSupply: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.totalSupplyFormatted,
      },
    }),
    monthVolume: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.monthVolumePriceFormatted,
      },
    }),
  }
}
